// Shared types used by both the REST API (api.proto) and the realtime game channel (game.proto).

// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file gunrun/v1/common.proto (package gunrun.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gunrun/v1/common.proto.
 */
export const file_gunrun_v1_common: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message gunrun.v1.TeamScores
 */
export type TeamScores = Message<"gunrun.v1.TeamScores"> & {
  /**
   * @generated from field: uint32 a = 1;
   */
  a: number;

  /**
   * @generated from field: uint32 b = 2;
   */
  b: number;
};

/**
 * Describes the message gunrun.v1.TeamScores.
 * Use `create(TeamScoresSchema)` to create a new message.
 */
export const TeamScoresSchema: GenMessage<TeamScores> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_common, 0);

/**
 * @generated from message gunrun.v1.Vec3
 */
export type Vec3 = Message<"gunrun.v1.Vec3"> & {
  /**
   * @generated from field: float x = 1;
   */
  x: number;

  /**
   * @generated from field: float y = 2;
   */
  y: number;

  /**
   * @generated from field: float z = 3;
   */
  z: number;
};

/**
 * Describes the message gunrun.v1.Vec3.
 * Use `create(Vec3Schema)` to create a new message.
 */
export const Vec3Schema: GenMessage<Vec3> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_common, 1);

/**
 * Content ids (weapons, attachments, perks, equipment, camos, maps) are the string slugs of
 * gr_core::ids (for example "kr7", "red_dot", "ghost_step", "frag", "carbon", "skyline").
 *
 * @generated from message gunrun.v1.WeaponLoadout
 */
export type WeaponLoadout = Message<"gunrun.v1.WeaponLoadout"> & {
  /**
   * @generated from field: string weapon = 1;
   */
  weapon: string;

  /**
   * @generated from field: repeated string attachments = 2;
   */
  attachments: string[];

  /**
   * @generated from field: string camo = 3;
   */
  camo: string;
};

/**
 * Describes the message gunrun.v1.WeaponLoadout.
 * Use `create(WeaponLoadoutSchema)` to create a new message.
 */
export const WeaponLoadoutSchema: GenMessage<WeaponLoadout> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_common, 2);

/**
 * @generated from message gunrun.v1.Loadout
 */
export type Loadout = Message<"gunrun.v1.Loadout"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: gunrun.v1.WeaponLoadout primary = 2;
   */
  primary?: WeaponLoadout | undefined;

  /**
   * @generated from field: gunrun.v1.WeaponLoadout secondary = 3;
   */
  secondary?: WeaponLoadout | undefined;

  /**
   * @generated from field: string lethal = 4;
   */
  lethal: string;

  /**
   * @generated from field: string tactical = 5;
   */
  tactical: string;

  /**
   * @generated from field: repeated string perks = 6;
   */
  perks: string[];
};

/**
 * Describes the message gunrun.v1.Loadout.
 * Use `create(LoadoutSchema)` to create a new message.
 */
export const LoadoutSchema: GenMessage<Loadout> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_common, 3);

/**
 * Mirrors gr_core::modes::ModeRules.
 *
 * @generated from message gunrun.v1.ModeRules
 */
export type ModeRules = Message<"gunrun.v1.ModeRules"> & {
  /**
   * @generated from field: gunrun.v1.GameMode mode = 1;
   */
  mode: GameMode;

  /**
   * @generated from field: uint32 score_limit = 2;
   */
  scoreLimit: number;

  /**
   * @generated from field: uint32 time_limit_sec = 3;
   */
  timeLimitSec: number;

  /**
   * @generated from field: uint32 rounds_to_win = 4;
   */
  roundsToWin: number;

  /**
   * @generated from field: uint32 max_players = 5;
   */
  maxPlayers: number;

  /**
   * @generated from field: uint32 team_size = 6;
   */
  teamSize: number;

  /**
   * @generated from field: float respawn_delay_sec = 7;
   */
  respawnDelaySec: number;

  /**
   * @generated from field: float spawn_protection_sec = 8;
   */
  spawnProtectionSec: number;

  /**
   * @generated from field: bool health_regen = 9;
   */
  healthRegen: boolean;

  /**
   * @generated from field: float regen_delay_sec = 10;
   */
  regenDelaySec: number;

  /**
   * @generated from field: float regen_per_sec = 11;
   */
  regenPerSec: number;

  /**
   * @generated from field: bool friendly_fire = 12;
   */
  friendlyFire: boolean;

  /**
   * @generated from field: uint32 countdown_sec = 13;
   */
  countdownSec: number;

  /**
   * @generated from field: uint32 end_screen_sec = 14;
   */
  endScreenSec: number;

  /**
   * @generated from field: uint32 hill_duration_sec = 15;
   */
  hillDurationSec: number;

  /**
   * @generated from field: uint32 hill_points_per_sec = 16;
   */
  hillPointsPerSec: number;

  /**
   * @generated from field: uint32 round_time_sec = 17;
   */
  roundTimeSec: number;

  /**
   * @generated from field: uint32 freeze_time_sec = 18;
   */
  freezeTimeSec: number;

  /**
   * @generated from field: uint32 round_end_sec = 19;
   */
  roundEndSec: number;

  /**
   * @generated from field: float plant_time_sec = 20;
   */
  plantTimeSec: number;

  /**
   * @generated from field: float defuse_time_sec = 21;
   */
  defuseTimeSec: number;

  /**
   * @generated from field: uint32 bomb_timer_sec = 22;
   */
  bombTimerSec: number;

  /**
   * @generated from field: uint32 halftime_after_rounds = 23;
   */
  halftimeAfterRounds: number;
};

/**
 * Describes the message gunrun.v1.ModeRules.
 * Use `create(ModeRulesSchema)` to create a new message.
 */
export const ModeRulesSchema: GenMessage<ModeRules> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_common, 4);

/**
 * @generated from enum gunrun.v1.GameMode
 */
export enum GameMode {
  /**
   * @generated from enum value: GAME_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GAME_MODE_FFA = 1;
   */
  FFA = 1,

  /**
   * @generated from enum value: GAME_MODE_TDM = 2;
   */
  TDM = 2,

  /**
   * @generated from enum value: GAME_MODE_KOTH = 3;
   */
  KOTH = 3,

  /**
   * @generated from enum value: GAME_MODE_DEFUSAL = 4;
   */
  DEFUSAL = 4,
}

/**
 * Describes the enum gunrun.v1.GameMode.
 */
export const GameModeSchema: GenEnum<GameMode> = /*@__PURE__*/
  enumDesc(file_gunrun_v1_common, 0);

/**
 * TEAM_A = Attackers in Defusal, TEAM_B = Defenders. FFA players are TEAM_NONE.
 *
 * @generated from enum gunrun.v1.Team
 */
export enum Team {
  /**
   * @generated from enum value: TEAM_NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: TEAM_A = 1;
   */
  A = 1,

  /**
   * @generated from enum value: TEAM_B = 2;
   */
  B = 2,
}

/**
 * Describes the enum gunrun.v1.Team.
 */
export const TeamSchema: GenEnum<Team> = /*@__PURE__*/
  enumDesc(file_gunrun_v1_common, 1);

/**
 * Skill of a server-side bot (docs/DESIGN.md "Bots").
 *
 * @generated from enum gunrun.v1.BotDifficulty
 */
export enum BotDifficulty {
  /**
   * @generated from enum value: BOT_DIFFICULTY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BOT_DIFFICULTY_EASY = 1;
   */
  EASY = 1,

  /**
   * @generated from enum value: BOT_DIFFICULTY_NORMAL = 2;
   */
  NORMAL = 2,

  /**
   * @generated from enum value: BOT_DIFFICULTY_HARD = 3;
   */
  HARD = 3,
}

/**
 * Describes the enum gunrun.v1.BotDifficulty.
 */
export const BotDifficultySchema: GenEnum<BotDifficulty> = /*@__PURE__*/
  enumDesc(file_gunrun_v1_common, 2);

/**
 * @generated from enum gunrun.v1.RoomKind
 */
export enum RoomKind {
  /**
   * @generated from enum value: ROOM_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * matchmaking warm-pool room
   *
   * @generated from enum value: ROOM_KIND_PUBLIC = 1;
   */
  PUBLIC = 1,

  /**
   * player-hosted lobby
   *
   * @generated from enum value: ROOM_KIND_CUSTOM = 2;
   */
  CUSTOM = 2,

  /**
   * formed by the ranked queue
   *
   * @generated from enum value: ROOM_KIND_RANKED = 3;
   */
  RANKED = 3,
}

/**
 * Describes the enum gunrun.v1.RoomKind.
 */
export const RoomKindSchema: GenEnum<RoomKind> = /*@__PURE__*/
  enumDesc(file_gunrun_v1_common, 3);

/**
 * Values match gr_core::modes::MatchPhase::index().
 *
 * @generated from enum gunrun.v1.MatchPhase
 */
export enum MatchPhase {
  /**
   * @generated from enum value: MATCH_PHASE_WARMUP = 0;
   */
  WARMUP = 0,

  /**
   * @generated from enum value: MATCH_PHASE_COUNTDOWN = 1;
   */
  COUNTDOWN = 1,

  /**
   * @generated from enum value: MATCH_PHASE_LIVE = 2;
   */
  LIVE = 2,

  /**
   * @generated from enum value: MATCH_PHASE_ROUND_FREEZE = 3;
   */
  ROUND_FREEZE = 3,

  /**
   * @generated from enum value: MATCH_PHASE_ROUND_LIVE = 4;
   */
  ROUND_LIVE = 4,

  /**
   * @generated from enum value: MATCH_PHASE_ROUND_END = 5;
   */
  ROUND_END = 5,

  /**
   * @generated from enum value: MATCH_PHASE_ENDED = 6;
   */
  ENDED = 6,
}

/**
 * Describes the enum gunrun.v1.MatchPhase.
 */
export const MatchPhaseSchema: GenEnum<MatchPhase> = /*@__PURE__*/
  enumDesc(file_gunrun_v1_common, 4);

/**
 * @generated from enum gunrun.v1.HitZone
 */
export enum HitZone {
  /**
   * @generated from enum value: HIT_ZONE_HEAD = 0;
   */
  HEAD = 0,

  /**
   * @generated from enum value: HIT_ZONE_BODY = 1;
   */
  BODY = 1,

  /**
   * @generated from enum value: HIT_ZONE_LIMB = 2;
   */
  LIMB = 2,
}

/**
 * Describes the enum gunrun.v1.HitZone.
 */
export const HitZoneSchema: GenEnum<HitZone> = /*@__PURE__*/
  enumDesc(file_gunrun_v1_common, 5);

